/**
 * VendorDonationService
 * Service for managing vendor donations
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor donation CRUD operations with vendor-specific queries
 */
export class VendorDonationService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorDonationService.DEFAULT_SERVICE_PATH,
            basePath: VendorDonationService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all donations for a specific vendor
     * @param vendorId - The vendor ID
     * @returns Array of vendor donation views
     */
    async getByVendor(vendorId) {
        const response = await this.getByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all donations for a specific vendor with full response
     * @param vendorId - The vendor ID
     * @returns ResponseData with array of vendor donation views
     */
    getByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}`);
        return this.http.get(url);
    }
    // ==================== MODEL VIEW QUERIES ====================
    /**
     * Get all vendor donations as model views
     * @returns Array of vendor donation model views
     */
    async getViews() {
        const response = await this.getViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all vendor donations as model views with full response
     * @returns ResponseData with array of vendor donation model views
     */
    getViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    /**
     * Get vendor donation model view by ID
     * @param id - Donation ID
     * @returns The vendor donation model view
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`VendorDonation view not found: id=${id}`);
        }
        return response.data;
    }
    /**
     * Get vendor donation model view by ID with full response
     * @param id - Donation ID
     * @returns ResponseData with vendor donation model view
     */
    getViewRaw(id) {
        const url = this.buildUrl(`${id}/view`);
        return this.http.get(url);
    }
    /**
     * Get all donation model views for a specific vendor
     * @param vendorId - Vendor ID
     * @returns Array of vendor donation model views
     */
    async getViewsByVendor(vendorId) {
        const response = await this.getViewsByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all donation model views for a specific vendor with full response
     * @param vendorId - Vendor ID
     * @returns ResponseData with array of vendor donation model views
     */
    getViewsByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}/views`);
        return this.http.get(url);
    }
}
VendorDonationService.DEFAULT_SERVICE_PATH = 'vendors';
VendorDonationService.BASE_PATH = 'api/vendor-donations';
//# sourceMappingURL=VendorDonationService.js.map